import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { BankingComponent } from './banking.component';
import { COMPONENTS } from './components/index';
import { ROUTES } from './banking.routes';
import { SERVICES } from './services/index';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(ROUTES)
  ],
  declarations: [
    BankingComponent,
    COMPONENTS
  ],
  providers: [
    SERVICES
  ],
  bootstrap: [ BankingComponent ]
})
export class BankingModule {
}
